export default __webpack_public_path__ + "static/media/play.c226d1a5.svg";